import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const xrf = {
    jpath: ['spectra', 'xrf'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default xrf;
//# sourceMappingURL=xrf.js.map